import { Component, EventEmitter, Output, Input, Injectable, OnInit,
  ElementRef, ViewChild, ViewContainerRef, TemplateRef, OnDestroy, AfterViewInit } from '@angular/core';

import { fromEvent } from 'rxjs';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {ProductModel, IDisplayableElements, IConfigObj, QuickAddBasketV1Service } from 'abs-ngx-library/src/lib/core';
import {CommonService, ABTestService , UserInfoService, UtilService, ProductUtilService, AemService, ProductFilterService, IntersectionObserverService } from 'abs-ngx-library/src/lib/core';

declare let $: any;

// Window global declaration
function _window(): any {
return window;
}

@Component({
selector: 'product-item-al-v1',
templateUrl: './product-item-al-v1.component.html'
})

@Injectable()
export class ProductItemALV1Component implements OnInit, OnDestroy, AfterViewInit {
// *** DFTA - commented out templates not being used for right-drawer

@ViewChild('productGridItemContainer', { read: ViewContainerRef, static: true }) productGridItemContainer: ViewContainerRef;
@ViewChild('DSTV2Template', { read: TemplateRef, static: true }) DSTV2Template: TemplateRef<any>;
@ViewChild('genericProductCardTemplate', { read: TemplateRef, static: true }) GenericProductCardTemplate: TemplateRef<any>;

@Output() removedProduct = new EventEmitter();
@Output() updateQscQtyEmitter = new EventEmitter();
private _product: ProductModel;

// DFTA - got value from console in prod
private imagePath: string = '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available';

@Input()
public calledBy: string;

@Input() isAnyProductHasAddlInfo: boolean;

@Input()
public crossSell: boolean;

@Input()
public crossSellType: string;

@Input()
public gridSource: string;

@Input()
public pathwaysWidget: any;

// Type of product card.  Possible values:
//    ecom (default card)
//    sns (schedule and save card)
@Input()
public cardType: string;
@Input() enableDstV2Theme: boolean;
@Input() isMarketPlaceEnabled: boolean;
@Input() public configObj: IConfigObj;
@Input() offers;

public productGridPage: string;
public removeProductHistoryUrl;
public removeProductHistory = false;
public attendDeliveryTxt;
public productDetailPath;
public productDetails: any;
public stepperCalledBy: string;
public sm = '575px';
public md = '768px';
public sponsoredProduct : boolean;
public pastPurchased: boolean;
public bgImgOpaque: string = 'product-image-opaque-full';
public loadingSpinner: boolean = false;
public isRightDrawer: boolean = false;
public itemAvailable: boolean = true;
public isArEnable: boolean = false;
public userChannel: string = '';
public isThemeBuilderEnabled: boolean;
public productCouponV2Visible: boolean = false;
public productOffers:any = {};

// README: Variable used for displaying the correct product price based on promo
public validPrice: number;

private subscription: Subscription = new Subscription();

public displayableElements: IDisplayableElements;
public isCheckboxChecked: boolean;
public enableOOSReDesign: boolean;
public sellerLandingPath: string = '';
private checkboxInput: HTMLInputElement;


public constructor(
  private http: HttpClient,
  private _elementRef: ElementRef,
  private _abTestService: ABTestService,
  public _commonService: CommonService,
  private _userInfoService: UserInfoService,
  private _utilService : UtilService,
  private _productUtilService: ProductUtilService,
  private _aemService: AemService,
  private _productFilterService: ProductFilterService,
  private intersectionObserverService: IntersectionObserverService,
  private _quickAddBasketService: QuickAddBasketV1Service

) {
  this.removeProductHistory = window['AB']['removeHistoryAction'] && window['AB']['removeHistoryAction'] == 'true';
  this.removeProductHistoryUrl = window['AB']['removeProductHistoryPath'];
  this.attendDeliveryTxt = window['AB']['attendDeliveryTxt'];

  // Check if theme builder is enabled
  this.isThemeBuilderEnabled = window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].isThemeBuilderEnabled ? true : false;

  this.userChannel = this._userInfoService.getUserChannel();
}

@Input('isRestricted')
public unAttendDeliveryFlag: boolean;

@Input('filter')
private _filter: boolean;

@Input('data')
set product(product: ProductModel) {
  window['AB']['searchRank'] = window['AB']['searchRank'] + 1;
  product['searchRank'] = window['AB']['searchRank'];
  product['updBtnText'] = !product['updBtnText'] ? 'Update' : product['updBtnText'];
  product['updBtnMode'] = !product['updBtnMode'] ? true : product['updBtnMode'];
  product['id'] = product['id'] ?  product['id'] : product['pid'] ?  product['pid'] : product['itemId'];
  product['pricePer'] = product['pricePer'] ?  product['pricePer'] : product['unitPrice'];
  product.unitQuantity = (product.unitQuantity) ? product.unitQuantity : product.unitOfMeasure;

  this._commonService.getPromoDescriptionAPI(product);
  this._commonService.checkStrikeThrough(product);
  const productName = product['name'] || product['description'];
  if (productName && this._commonService.isSeoEnabled()) {
        this.productDetailPath = this._commonService.buildSeoPdpUrl(productName, product.id);
  } else {
    this.productDetailPath = this._commonService.getProductDetailPath(this.configObj?.programType);
    if (this.productDetailPath) {
        this.productDetailPath = this.productDetailPath.replace('(bpn)', product.id);
    }
  }

  product['name'] = !product['name'] && product['description'] ? product['description'] : product['name'];
  product['fullName'] = product['name'] && product['name'].length > 60 ? product['name'] : product['fullName'];
  product['name'] = this.addElipsis(product['name']);

  this._product = product;
  this.sponsoredProduct = product['featured'];
  this.pastPurchased = product['pastPurchased'];
  if (!this._filter) {
    this._productFilterService.addDepartment(product['departmentName']);
}
}

get product(): ProductModel {
  return this._product;
}

public ngOnInit() {
  this.configObj = this.product.isMarketplaceItem == 'Y' ? { programType: 'mkp'} : this.configObj;
  this.enableOOSReDesign = this.calledBy == 'buy-it-again';
  this.isCheckboxChecked = true;
  // Set bool to value in localStorage
  if (this.calledBy === 'buy-it-again-qsc') {
    const selectAllSubscription = this._quickAddBasketService.selectAllItems$.subscribe((value) => {
      if (this.isCheckboxChecked == value) {
        return;
      }
      this.toggleCheckbox();
    });
    this.subscription.add(selectAllSubscription);
    this.isCheckboxChecked = this._quickAddBasketService.isProductSelected(this.product.id);
  }
  if (!this.isScheduleAndSaveCard()) {
      // Check for arFlag else listen to arFlagLoaded
      if(window['AB']['arFlagLoaded']){
          this.isArEnable = window['AB']['arFlag']['display'];
      } else {
          this.subscription.add(
              fromEvent(document, 'arFlagLoaded').subscribe(event => {
                  this.isArEnable = event && event['detail'] && event['detail']['arFlag'] ? event['detail']['arFlag']['display'] : false;
              })
          );
      }
  }
  this.isRightDrawer = true;
  // Quantity Stepper callde By, may be editpasrpurchases or last order page.
  if (this.removeProductHistory && this.calledBy === 'historylist') {
      this.stepperCalledBy = 'editpastpurchases';
  } else if (this.calledBy === 'historylastorder' || this.calledBy === 'erumslastorder' || this.calledBy === 'last-order') {
      this.stepperCalledBy = 'lastorder';
  } else if (this.calledBy === 'crossSellComp') {
      this.stepperCalledBy = 'crosssell';
  }

  if (!this.enableOOSReDesign) {
    this.itemAvailable = this._commonService.isItemAvailable_v2(this.product, this.configObj?.programType);
  } else {
      this.itemAvailable = this._commonService.isItemAvailable_v3(this.product, this.configObj?.programType);
  }

  this.productCouponV2Visible = this.itemAvailable && this.calledBy !== 'c-products-by-upc-drawer' && this.calledBy != 's-bogo';

  //get offersObject and set productOffers obj for snsOneTime coupons 
  this.productOffers = this._commonService.getOffersByUpc(this.product,this.offers);

  if (this.itemAvailable) {
      // README: Update product price value that needs to be displayed in the card
    this.validPrice = this._commonService.getValidProductPrice(this._product);
  }

  // This will not display buy-it-again label on buy-it-again page product cards
  if (this.calledBy === 'buy-it-again' || this.calledBy === 'buy-it-again-qsc') {
      this.pastPurchased = false;
  }

  this.loadGridProductItem();

  // analytics
  this._updateAnalytics(this._product);
  if (this.product['averageWeight'] < 1 && this.product['averageWeight'] > 0 && this.product.displayUnitQuantityText !== 'ea') {
      this.product['averageWeightStr'] = this.product['averageWeight'][0].substring(1, 4);
  }
  this.setSellerLandingPath();
  this.setDisplayableElements();
}

private setSellerLandingPath()
{
  if(this.configObj?.programType && (this.configObj.programType === 'mkp' || this.configObj.programType === 'mkp-carousel' || (this.product?.isMarketplaceItem && this.product.isMarketplaceItem === 'Y'))) {
    this.sellerLandingPath = this._commonService.getSellerLandingPath(this.product.sellerId);
  }
}

public _updateAnalyticsCTA(caller) {
  if (_window().AB?.DATALAYER) {
      _window().AB.DATALAYER.analyticsCTATracking(`cta:global-search|${caller === 'productCards'
          ? 'product-cards|see-results-on-marketplace' : `internal-link|${this.product.sellerName}`}`);
  }
}
public loadGridProductItem() {
  // DFTA - only using 1 template for dnf flow
  switch (true){
    case (this.configObj?.appName && this.configObj?.appName === 'dnf'):
      this.productGridItemContainer.createEmbeddedView(this.DSTV2Template); // DFTA - only this template for dnf flow
          break;
    default:
      this.productGridItemContainer.createEmbeddedView(this.GenericProductCardTemplate);
  }
}

public ngAfterViewInit(): void {
  if (this.product &&
      this.product['adId'] || this.product.eventTracking) {
      this.intersectionObserverService.createObserver(this._elementRef.nativeElement, this.product);
  }

  // Trigger lazy loading for all pagination types.
  if (window['AB']['LAZYLOAD'] && typeof window['AB']['LAZYLOAD'].init == 'function') {
      window['AB']['LAZYLOAD'].init();
  }

  // Set the initial state of the checkbox.
  if (this.calledBy === 'buy-it-again-qsc') {
    this.checkboxInput = document.querySelector<HTMLInputElement>(`#pg${this.product.id}-chk`);
    this.checkboxInput.checked = this.isCheckboxChecked;
  }
}

public sendAdIdClickEvent() {
  this._commonService.sendSponsoredProductClickEvent(this.product,'productCardGridOrCrossSell','viewProductDetails');
}

public onProductCouponDetailsChange(productDetails) {
  this.productDetails = productDetails;
}

public setProductDetails() {
  localStorage.setItem('currentProduct', JSON.stringify(this.productDetails));
}

public removeProductInHistory(event): void {

  const target = event.target || event.srcElement || event.currentTarget;
  const productId = this.product['id'];
  const productName = this.product['name'];
  let objRequest: any = {
      'ProductId': productId,
  };

  objRequest = JSON.stringify(objRequest);

  this.http.post(this.removeProductHistoryUrl, objRequest).subscribe(response => {

      // Read the result field from the JSON response.
      if (!response['ack']) {
          $(target).parents('.product-item-' + productId).parent().remove();
          this.removedProduct.emit(productName);
      }
  });
}

public getImageUrl(id: string, viewport: string): string {
  const modifiedImagePath = this.imagePath;
  return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
}

private addElipsis(productName) {
  if (productName && productName.length > 60) {
      productName = productName.trim();
      const firstLetters = productName.split('').filter((name, index) => index < 30).join('');
      const lastLetters = productName.split('').reverse().filter((name, index) => index < 20).reverse().join('');
      productName = firstLetters.trim() + '... ' + lastLetters.trim();
  }

  return productName;
}

public onLoadSpinner(event: boolean) {
  this.loadingSpinner = event;
}

/**
* Event with removed product from quantity stepper.
*/
public onRemovedItem(event) {
  this.removeProductInHistory(event);
}

public onSetBgImgOpaque(event) {
  if (event === true) {
      this.bgImgOpaque = 'product-image-opaque-half';
  } else if (event === false) {
      this.bgImgOpaque = 'product-image-opaque-full';
  }
}

// Sets the pfmDetail in localStorage to be used in analytics tracking on pdp navigation
public setPfmDetailProduct(isSpotlight?:boolean) {
  if (window['AB']?.DATALAYER) {
    const analyticsProductInfo = {
        isSpotlight : isSpotlight,
        calledBy: this.calledBy,
        isPastPurchased: this.pastPurchased,
        isSponsored: this.sponsoredProduct,
        pathwaysWidget: this.pathwaysWidget
    };
    window['AB'].DATALAYER.setPfmDetailProductItemToPDP(this._elementRef.nativeElement, this.product, analyticsProductInfo);
    window['AB'].DATALAYER.analyticsCTATracking(`cta:${window['AB'].DATALAYER.pathSections?.join(':')}|link|product`);
  }
}

private _updateAnalytics(product) {
  if (product['pastPurchased'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].setPastPurchasedImpressions('aisles');
  }
}

public analyticsSimilarItemsCTA() {
  if (window['AB']?.DATALAYER) {
    window['AB'].DATALAYER.analyticsCTATracking(`cta:${window['AB'].DATALAYER.pathSections?.join(':')}|link|view-similar-items`);
  }
}

/**
* Method to display AR subscription block or not on product card
*/
public showArSubscription = (): boolean =>
    this.isArEnable && !!this.product && this.product.isArProduct && this._commonService.isActiveProduct(this.product);

ngOnDestroy() {
  this.subscription.unsubscribe();
}

  /**
  * Method to determine path/href for when product is clicked.
  */
  public getProductDetailPath() {
    if (this.configObj?.bannerDomain && this.configObj?.appName && this.configObj?.appName === 'weeklyAd'){
      const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
      return bannerDomainUrl + this.productDetailPath;
    } else
    if (this.isScheduleAndSaveCard() || this.configObj?.appName === 'dnf') {
      return null;
    }
    else {
      if (this.product?.name && this._commonService.isSeoEnabled()) {
        return this._commonService.buildSeoPdpUrl(this.product['fullName'] || this.product.name, this.product.id);
      }
      let pdpPath = this._commonService.getProductDetailPath(this.configObj?.programType);
      //ACIP-95256 : In DNF details, the qualifying products returned undefined error
      pdpPath = pdpPath ? pdpPath.replace('(bpn)', this.product.id) : '' ;
      return pdpPath;
    }
  }

  /**
   * Method to handle clicking on product
  **/
  public onProductClicked() {
    if (this.isScheduleAndSaveCard()) {
        _window().openItemDetail(this.product.id);
    }
    // make ad relevance call for all products
    if (!this._aemService.getFeatureFlagByNameDisable('disableAdRelevance')) {
      this._commonService.recordRelevanceImpression(this.product, 'productCardGridOrCrossSell', 'viewProductDetails');
  }
  }

  public isScheduleAndSaveCard(): boolean {
    return this.cardType === 'sns';
  }

  public isLBProduct(): boolean {
    return this.product?.displayType === '3' && (this.product?.sellByWeight === 'W' || this.product?.sellByWeight === 'P');
  }

  public showPCReview(product){
    return (this.calledBy !== 'buy-it-again'
        && product
        && product.productReview
        && product.productReview.isReviewDisplayEligible === 'true'
        && product.productReview.avgRating
        && product.productReview.avgRating != ''
        && product.productReview.avgRating != '0.0'
        && product.productReview.avgRating != '0'
        && product.productReview.avgRating != null);
    }
    /**
     * Set Product Card DisplayableElement by appName
     */
    private setDisplayableElements(){
        const programType = this.configObj?.programType ? this.configObj?.programType : 'abs';
        this.displayableElements = this._productUtilService.getProductDisplayableElementsByProgramType(programType);
    }

  /**
   * Sets 'selected' property of product with matching id in local storage.
   * @param id id of the product to modify in quickAddBasket
   * @param state boolean state to set property 'selected' to
   */
  public setQuickAddBasketSelectedProperty(id: string, state: boolean) {
    this._quickAddBasketService.setQuickAddBasketSelectedProperty(id, state);
  }

  /**
   * Modifies selected property of item in Quick Add Basket and sets correct checkbox styling.
   * @param event 
   */
  public onCheckboxClick(event?: Event):void {
    if (this._userInfoService.getUserChannel() == 'instore') {
      window['rightDrawerComp'].closeDrawer();
      window['storeFulfillmentModal'].component.setModalDisplayData(2);
      // Prevent checkbox from toggling. 
      event?.preventDefault();
      return;
    } else {
      this.toggleCheckbox();
      this.setQuickAddBasketSelectedProperty(this.product.id, this.isCheckboxChecked);
    }
  }

  private toggleCheckbox() {
    this.isCheckboxChecked = !this.isCheckboxChecked;
    this.checkboxInput.checked = this.isCheckboxChecked;
  }

  /**
     * On click of View Similar button , go to similar products url or show cross sell component based on EOT flag
     *
     * @TODO - setup check for EOT flag once flag is setup
     */
  public viewSimilarClick() {
    if (this.calledBy && this.calledBy == 'buy-it-again') {
        this._commonService.showBiaLPCrossSell(this.product.id);
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.setViewSimilarItemsClick(this._product);
        }
    }
    else {
        let redirectUrl = "/bin/safeway/product/similar?aisleId={product.aisleId}";
        redirectUrl = redirectUrl.replace('{product.aisleId}', this.product.aisleId);
        window.location.href = redirectUrl;
    }
  }
}
